export default __webpack_public_path__ + "static/media/ncso-provincial.53cfa645.png";